import Contact from "#components/Contact";
import { CurvedDivider } from "#components/CurvedDivider";
import ServiceArea from "#sections/ServiceArea";
import React from "react";
function ContactUsPage() {
  return (
    <>
      <Contact />

      <CurvedDivider />

      <ServiceArea />
    </>
  );
}
export default ContactUsPage;
